// extracted by mini-css-extract-plugin
export var fileExt = "_s8-8";
export var fileIcon = "_s8-6";
export var fileLink = "_s8-5";
export var fileName = "_s8-7";
export var image = "_s8-1";
export var imageError = "_s8-3";
export var imageErrorIcon = "_s8-4";
export var imageLink = "_s8-0";
export var imageLoaded = "_s8-2";